import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import { normalizeVideo } from 'shared/redux/helpers/normalized';


const ACTIONS = createAsyncActions('CLIENT.VIDEO.UPDATE', ['SUCCESS']);
export const NAMES = ACTIONS.NAMES;
const { SUCCESS } = ACTIONS;

export { SUCCESS };


export default function (data) {
  data = normalizeVideo(data);

  return function (dispatch) {
    dispatch(SUCCESS({}, { data }));
  };
}



// WEBPACK FOOTER //
// ./src/shared/redux/client/actions/video/update.js